<template>
     <div id="myModal" class="modal">
        <div class="modal-content slideDown" v-if='park'>
            <span class="close" @click='sendClose'>&times;</span>
            <div class='park-modal__header'>
              <h2 class='park-modal__name'>{{ park.fullName }}</h2>
              <img class='park-modal__background' :src='park.image.url' :alt='park.image.altText'/>
            </div>
            <div class="park-modal__content">
                <div class="park-modal__image">
                  <img :src='park.image.url' :alt='park.image.altText'/>
                  <p class="park-modal__image-caption">{{park.image.caption}}</p>
                </div>
                <div class="park-modal__info">
                  <p>{{ park.description }}</p>
                  <p><strong>Location:</strong>
                    <span class="park-modal__info-address">{{ park.address[0] }}</span>
                    <span class="park-modal__info-address">{{ park.address[1] }}</span>
                  </p>
                  <p><strong>Operating Hours:</strong>{{ park.operatingHours[0].description }}</p>
                  <a class="park-modal__info-button" :href='park.directionsUrl' target="_blank">Plan Your Visit</a>
                </div>
            </div>
        </div>
     </div> 
</template>

<script>

export default {
  name: 'Modal',
  props: ['park'],
  methods: {
      sendClose() {
          this.$emit("close-modal");
      }
  }
}

</script>

<style lang='scss' scoped>
.slideDown{
	animation-name: slideDown;
	-webkit-animation-name: slideDown;	

	animation-duration: 1s;	
	-webkit-animation-duration: 1s;

	animation-timing-function: ease;	
	-webkit-animation-timing-function: ease;	

	visibility: visible !important;						
}

@keyframes slideDown {
	0% {
		transform: translateY(-100%);
	}
	65%{
		transform: translateY(0%);
	}
	80%{
		transform: translateY(1%);
	}		
	100% {
		transform: translateY(0%);
	}		
}

@-webkit-keyframes slideDown {
	0% {
		-webkit-transform: translateY(-100%);
	}
	65%{
		-webkit-transform: translateY(0%);
	}
	80%{
		-webkit-transform: translateY(1%);
	}	
	100% {
		-webkit-transform: translateY(0%);
	}	
}

     /* The Modal (background) */
.modal {
  /*display: none;  Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 10; /* Sit on top */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0,0,0); /* Fallback color */
  background-color: rgba(0,0,0,0.4); /* Black w/ opacity */
}

/* Modal Content/Box */
.modal-content {
  background-color: #fefefe;
  margin: 15px auto; 
  border: 1px solid #888;
  width: 80%; /* Could be more or less, depending on screen size */
  position: relative;
}

/* The Close Button */
.close {
  color: #e1e1e1;
  position: absolute;
  top: 15px;
  right: 15px;
  font-size: 28px;
  font-weight: bold;
  z-index: 12;
}

.close:hover,
.close:focus {
  color: #aaa;
  text-decoration: none;
  cursor: pointer;
} 

p {
    text-align: left;
    margin: 15px 0;
}

p strong { 
    display: block; 
}
.park-modal {
  &__header {
    width: 100%;
    height: 0;
    padding-bottom: max(10%, 60px);
    position: relative;
    z-index: 11;
    background-color: #373d39;
  }
  
  &__name {
    z-index: 12;
    color: #fff;
    text-shadow: 1px 1px 5px rgba(0,0,0,0.75);
    font-size: 1.5em;
    line-height: 1.25;
    margin: 15px;
    position: absolute;
    top:0;
    left:0;
    width:calc(100% - 30px);
    height:calc(100% - 30px);
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
  }

  &__background {
    position: absolute;
    top:0;
    left:0;
    width:100%;
    height:100%;
    object-fit:cover;
    z-index: 1;
    filter: brightness(0.5) blur(5px);
  }

  &__content {
    padding: 15px;
    display: flex;
    flex-flow: column;
  }

  &__image {
      padding: 15px;
  
      &-caption {
        font-size: smaller;
        text-align: center;
      }
  }

  &__image img {
      max-width: 100%;
  }

  &__info {
    padding: 15px;
  
    &-address {
      display: block;
    }

    &-button {
      text-decoration: none;
      display: inline-block;
      background: #42b970;
      color: #ffffff;
      padding: 0.5rem 1.5rem;
      transition: 0.25s ease;

      &:hover {
        opacity: 0.75;
      }
    }
  }
}

  
@media (min-width: 768px) {
    .park-modal__content {
        flex-flow: row;
    }
    .park-modal__image {
        flex-basis: 50%;
    }
    .park-modal__info {
        flex-basis: 50%;
    }
}
</style>
